// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DisplayOnlyMember",
    "UserBoundMember"
  ]);
}

function unwrap_response_currentAccountV5_profile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "IndividualAccountProfile",
    "TeamAccountProfile"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"currentAccountV5_profile_TeamAccountProfile_publicUrl":{"b":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node_UserBoundMember":{"f":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node_DisplayOnlyMember":{"f":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node":{"u":"response_currentAccountV5_profile_TeamAccountProfile_members_edges_node"},"currentAccountV5_profile":{"u":"response_currentAccountV5_profile"}}};

let wrapResponseConverterMap = {
  response_currentAccountV5_profile_TeamAccountProfile_members_edges_node: RescriptRelay_Internal.wrapUnion,
  response_currentAccountV5_profile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"currentAccountV5_profile_TeamAccountProfile_publicUrl":{"b":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node_UserBoundMember":{"f":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node_DisplayOnlyMember":{"f":""},"currentAccountV5_profile_TeamAccountProfile_members_edges_node":{"u":"response_currentAccountV5_profile_TeamAccountProfile_members_edges_node"},"currentAccountV5_profile":{"u":"response_currentAccountV5_profile"}}};

let responseConverterMap = {
  response_currentAccountV5_profile_TeamAccountProfile_members_edges_node: unwrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node,
  response_currentAccountV5_profile: unwrap_response_currentAccountV5_profile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function accountMemberRole_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "UNKNOWN" || $$enum === "ASSOCIATE" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "BUYER_SPECIALIST" || $$enum === "SHOWING_ASSISTANT" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "PARTNER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "OWNER" || $$enum === "LISTING_MANAGER" || $$enum === "OPERATIONS_MANAGER" || $$enum === "LISTING_SPECIALIST" || $$enum === "MARKETING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRole_fromString = accountMemberRole_decode;

let Utils = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: accountMemberRole_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerProfileRole",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "width",
        "value": 48
      }
    ],
    "kind": "ScalarField",
    "name": "url",
    "storageKey": "url(width:48)"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedTeamAccountProfileMembersSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AccountV5",
          "kind": "LinkedField",
          "name": "currentAccountV5",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v0/*: any*/),
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "type": "IndividualAccountProfile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": null,
                          "args": (v3/*: any*/),
                          "concreteType": "TeamAccountProfileMemberConnection",
                          "kind": "LinkedField",
                          "name": "members",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamAccountProfileMemberEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v1/*: any*/),
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            (v4/*: any*/),
                                            {
                                              "args": null,
                                              "kind": "FragmentSpread",
                                              "name": "UnifiedTeamAccountProfileMemberRow_userMember"
                                            }
                                          ],
                                          "type": "UserBoundMember",
                                          "abstractKey": null
                                        },
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            (v4/*: any*/),
                                            {
                                              "args": null,
                                              "kind": "FragmentSpread",
                                              "name": "UnifiedTeamAccountProfileMemberRow_displayOnlyMember"
                                            }
                                          ],
                                          "type": "DisplayOnlyMember",
                                          "abstractKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    "action": "THROW"
                                  }
                                ],
                                "storageKey": null
                              },
                              "action": "THROW"
                            }
                          ],
                          "storageKey": "members(first:100)"
                        },
                        "action": "THROW"
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnifiedTeamAccountProfileMembersSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountV5",
        "kind": "LinkedField",
        "name": "currentAccountV5",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "TeamAccountProfileMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamAccountProfileMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Agent",
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "id",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProfilePhoto",
                                        "kind": "LinkedField",
                                        "name": "profilePhoto",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "role",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibility",
                                    "storageKey": null
                                  }
                                ],
                                "type": "UserBoundMember",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProfilePhoto",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "DisplayOnlyMember",
                                "abstractKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "members(first:100)"
                  }
                ],
                "type": "TeamAccountProfile",
                "abstractKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "695a1cec26611508cac5353015c001bf",
    "id": null,
    "metadata": {},
    "name": "UnifiedTeamAccountProfileMembersSettingsQuery",
    "operationKind": "query",
    "text": "query UnifiedTeamAccountProfileMembersSettingsQuery {\n  currentAccountV5 {\n    viewerProfileRole\n    profile {\n      __typename\n      ... on IndividualAccountProfile {\n        __typename\n      }\n      ... on TeamAccountProfile {\n        publicUrl\n        members(first: 100) {\n          edges {\n            node {\n              __typename\n              ... on UserBoundMember {\n                nodeId\n                ...UnifiedTeamAccountProfileMemberRow_userMember\n              }\n              ... on DisplayOnlyMember {\n                nodeId\n                ...UnifiedTeamAccountProfileMemberRow_displayOnlyMember\n              }\n              ... on Node {\n                __isNode: __typename\n                __typename\n                nodeId\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  displayName\n  title\n  profilePicture {\n    url(width: 48)\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_userMember on UserBoundMember {\n  nodeId\n  agent {\n    id\n    displayName\n    profilePhoto {\n      url(width: 48)\n    }\n    nodeId\n  }\n  role\n  title\n  visibility\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node = RescriptRelay_Internal.wrapUnion;

let wrap_response_currentAccountV5_profile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node = unwrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node;
exports.wrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node = wrap_response_currentAccountV5_profile_TeamAccountProfile_members_edges_node;
exports.unwrap_response_currentAccountV5_profile = unwrap_response_currentAccountV5_profile;
exports.wrap_response_currentAccountV5_profile = wrap_response_currentAccountV5_profile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
